module.exports = __webpack_public_path__ + "assets/tenbisCard-038c9d.svg";